/**
 * Get the value of a query parameter from window.location.search
 * without converting `+` into spaces.
 *
 * @param name - Query parameter name
 * @returns The decoded value or null if not found
 */
function getParamNoPlus(name: string): string | null {
  const regex = new RegExp(`[?&]${name}=([^&]+)`);
  const match = regex.exec(window.location.search);
  return match ? decodeURIComponent(match[1]) : null;
}

/**
 * Get the redirect URL from the `redirect-to` param,
 * or fallback to window.location.origin.
 */
export function getRedirectToUrl(): string {
  return getParamNoPlus('redirect-to') || window.location.origin;
}
